export const showWorkCircleBanners = true;
export const showWorkCircleCards = true;
